module.exports = __webpack_public_path__ + "static/media/Sunflower_Green.e2dc28f6.svg";